import { SectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { isExcessEndorsement, Quote } from '../../../domain'
import { usePolicyExcessConfig } from '../../../hooks/excess'
import { Endorsements } from '../endorsements'

export interface ExcessEndorsementsProps extends SectionProps {
  quote: Quote
}

export const ExcessEndorsements: FunctionComponent<ExcessEndorsementsProps> = ({
  quote,
  ...props
}) => {
  const excessConfig = usePolicyExcessConfig()

  const endorsements = quote.endorsements.filter(isExcessEndorsement(excessConfig))

  return <Endorsements quote={quote} endorsements={endorsements} {...props} />
}
